import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { OurNode } from "@src/cloud-connect/poc/our-node";

export class MachineCheckBoxClickHandler {
  toggleSelected(node: OurNode) {
    const logger = getLogger();
    const t0 = performance.now();
    logger.debug("t0 - start of action", t0);
    const machineStructureNodeset = getMachineStructureNodeset();

    const newSelectedIds = new Set(machineStructureNodeset.selectedNodeIds);

    if (node.selected) {
      node.deselectYourselfAndAllChildren((n) => {
        newSelectedIds.delete(n.id);
      });
    } else {
      node.selectYourselfAndAllChildren((n) => {
        newSelectedIds.add(n.id);
      });
    }

    machineStructureNodeset.setSelectedNodeIds(newSelectedIds);

    const rootNode = node.returnRootNodeFromOurNode();
    machineStructureNodeset.setRootNode(rootNode);
    const flatMap = rootNode.createMapFromOurNodeTree();
    machineStructureNodeset.setFlatMap(flatMap);
    const t1 = performance.now();
    logger.debug("t1 - end of action", t1);
    logger.debug(
      `Action to to select node with new structure took ${
        t1 - t0
      } milliseconds.`,
    );
  }
}
